import { Controller } from '@hotwired/stimulus';

// A second click on Submit while the first POST is still in flight sends the
// same cached upload twice. The first request stores the file, which moves it
// out of the upload cache, so the second cannot find it and the customer sees
// an error page for a submission that actually went through.
//
// The submit is cancelled rather than the button disabled: a disabled
// submitter drops its name from the request, and these forms branch on which
// button ("Upload File", "Done Uploading Proof") was pressed.
export default class extends Controller {
  connect() {
    this.submitting = false;
  }

  guard(event) {
    if (this.submitting) {
      event.preventDefault();
      return;
    }

    this.submitting = true;
  }

  // A Turbo submission leaves the page in place, and a page restored from the
  // back-forward cache keeps its state, so either would otherwise stay locked.
  reset() {
    this.submitting = false;
  }
}
